// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';

import Grid from '@material-ui/core/Grid';

import Backdrop from '@material-ui/core/Backdrop/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SnackbarComponent } from '../../../../../core/utils/components/snackbar-component';

import EditIcon from '@material-ui/icons/Edit';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Fade,
  InputAdornment,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { ALERT_DEFINITIONS, ALERT_TYPE } from '../../../../../core/types/alerts';
import { ExpandMoreRounded, HelpOutlineRounded, SaveOutlined } from '@material-ui/icons';
import { editAlertSettings } from '../../../data/datasources/edit-alert-settings';
import { useDispatch } from 'react-redux';
import { refreshMeAction } from '../../../../me/presentation/redux/actions/me-actions';
import { SETTINGS_LOAD_SUCCESS } from '../../redux/types/settings-types';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // maxWidth: 752
    margin: theme.spacing(2, 0)
  },
  demo: {
    backgroundColor: theme.palette.background.paper
  },
  title: {
    margin: theme.spacing(4, 0, 2)
  },
  form: {
    margin: theme.spacing(2, 2, 2, 2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

const DEFAULT_ALERT = {
  enabled: false,
  target: 0,
  buffer: 0
};

function AlertAction(props) {
  const actionConfig = {
    target: {
      heading: 'Target',
      description: 'The expected target timeframe for the action to be completed.'
    },
    buffer: {
      heading: 'Buffer',
      description:
        'Extra time to wait before checking again if the issue hasn’t been resolved. If still unresolved, the alert’s priority may be increased.'
    }
  };
  const { editing, alert, setAlert, variant } = props;

  const action_alert = ALERT_DEFINITIONS[alert.type].action || false;
  const config = actionConfig[variant];

  const isError = Number(alert[variant]) <= 0;

  if (!editing) {
    return (
      <Grid
        item
        xs={12}
        md={6}
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <Typography variant="body2" color="textPrimary">
          {config.heading}
        </Typography>
        <Tooltip
          placement="top"
          slots={{
            transition: Fade
          }}
          slotProps={{
            transition: { timeout: 600 }
          }}
          title={action_alert ? 'Not applicable for action-based alerts' : config.description}
        >
          <Typography variant="body2" color="textSecondary" style={{ paddingLeft: 8 }}>
            {action_alert ? 'N/A*' : `${alert[variant]} mins`}
          </Typography>
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid
      item
      xs={12}
      md={6}
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <TextField
        id="outlined-full-width"
        label={config.heading}
        type="number"
        size="small"
        variant="outlined"
        InputProps={{
          endAdornment: <InputAdornment position="end">mins</InputAdornment>,
          inputProps: { min: 1 }
        }}
        error={isError}
        helperText={isError ? `Value must be greater than 0` : ''}
        value={alert[variant]}
        onChange={(e) => setAlert({ ...alert, [variant]: +e.target.value })}
      />
    </Grid>
  );
}

function AlertCard(props) {
  const { alert_type, organization, openBackdrop, closeBackdrop, showSnackbar } = props;

  const { alerts } = organization;

  const $alert = alerts.find((a) => a.type === alert_type);
  const [alert, setAlert] = useState({ ...DEFAULT_ALERT, type: alert_type, ...$alert });
  const [editing, setEditing] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const dispatch = useDispatch();
  const action_alert = ALERT_DEFINITIONS[alert_type].action || false;

  const toggleEditing = () => {
    if (editing) {
      if (alert.target <= 0 || alert.buffer <= 0) {
        showSnackbar('error', 'Target and/or buffer must be greater than 0');
        return;
      }
      submitChanges();
    }
    setEditing(!editing);
  };

  const toggleEnabled = () => {
    const willEnable = !alert.enabled;

    setAlert((prev) => ({ ...prev, enabled: willEnable }));

    // Do not submit the enabled change if the alert's target or buffer is not set correctly as this direcetly impacts the alert's functionality.
    // User is required to set the target and buffer values before enabling the alert. It will batch the changes once the user submits the target and buffer values and saves.
    // This is not applicable to action alerts as they are immediate and do not care about the target or buffer values.
    if (willEnable && !action_alert && (alert.target <= 0 || alert.buffer <= 0)) {
      toggleEditing();
      showSnackbar('warning', 'Alert must have a target and buffer greater than 0 to be enabled.');

      return;
    }

    setPendingSubmit(true);
  };

  const submitChanges = async () => {
    try {
      openBackdrop();
      const result = await editAlertSettings(alert);
      showSnackbar('success', 'Alert settings updated successfully.');

      dispatch({ type: SETTINGS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      console.error('Error updating alert settings:', error, error.message);
      showSnackbar('error', 'Error updating alert settings. Please try again.');
    } finally {
      closeBackdrop();
      dispatch(refreshMeAction());
    }
  };

  useEffect(() => {
    if (pendingSubmit) {
      submitChanges();
      setPendingSubmit(false);
    }
  }, [alert.enabled, pendingSubmit]);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        flexGrow: 1,
        border: '1.5px solid #ccc',
        alignContent: 'center',
        borderRadius: 4
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 8
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap'
          }}
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 0,
              fontWeight: 'bold',
              paddingRight: 8
            }}
          >
            {ALERT_DEFINITIONS[alert_type].heading}
          </Typography>
          {action_alert && (
            <Tooltip
              placement="top"
              slots={{
                transition: Fade
              }}
              slotProps={{
                transition: { timeout: 600 }
              }}
              title="This alert triggers immediately based on driver actions and does not use timing settings."
            >
              <Chip
                label="ACTION"
                variant="outlined"
                size="small"
                style={{ alignSelf: 'center' }}
              />
            </Tooltip>
          )}
        </div>
        <Button
          variant="contained"
          size="small"
          style={{
            backgroundColor: alert.enabled ? '#4caf50' : '#f44336',
            color: '#fff'
          }}
          onClick={toggleEnabled}
        >
          {alert.enabled ? 'Enabled' : 'Disabled'}
        </Button>
      </div>
      {/* Card Content */}
      <Typography
        varient="body2"
        color="textSecondary"
        component="p"
        style={{ paddingLeft: 8, paddingTop: 4 }}
        paragraph
      >
        {ALERT_DEFINITIONS[alert_type].description}
      </Typography>
      <Grid
        container
        spacing={2}
        style={{ paddingLeft: 8, paddingBottom: 8, alignItems: 'center' }}
      >
        <Grid
          item
          xs={11}
          md={11}
          style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
        >
          <AlertAction editing={editing} alert={alert} setAlert={setAlert} variant={'target'} />
          <AlertAction editing={editing} alert={alert} setAlert={setAlert} variant={'buffer'} />
        </Grid>
        {!action_alert && (
          <Grid
            item
            xs={1}
            md={1}
            style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
          >
            <IconButton
              aria-label="comments"
              style={{
                marginTop: '-4px'
              }}
              onClick={toggleEditing}
            >
              {editing ? <SaveOutlined /> : <EditIcon />}
            </IconButton>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

function AlertSettingsList({ organization, openBackdrop, closeBackdrop, showSnackbar }) {
  const classes = useStyles();
  const isTDT = organization?.integration_flow?.enabled && organization?.integration_flow?.type === 'TDT';
  return (
    <div className={classes.demo}>
      <Accordion defaultExpanded>
        <AccordionSummary
          aria-controls="alert-settings-content"
          id="alert-settings-header"
          expandIcon={<ExpandMoreRounded />}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="subtitle1">Alert Settings</Typography>
            <Tooltip
              placement="top"
              slots={{
                transition: Fade
              }}
              slotProps={{
                transition: { timeout: 600 }
              }}
              title="Configure how your alerts behave. You can enable or disable specific alerts, set expected timeframes for key actions, and control how quickly unresolved issues are followed up on."
            >
              <HelpOutlineRounded fontSize="small" style={{ marginLeft: 6 }} />
            </Tooltip>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className={classes.form} style={{ width: '100%' }}>
            <Grid container spacing={2}>
              {Object.values(ALERT_TYPE).filter((type) => {
                if (type === ALERT_TYPE.PICK_ORDER_DELAY) return isTDT; 
                return true;
              }).map((alert_type) => {
                return (
                <Grid item xs={12} md={6} key={alert_type}>
                  <AlertCard
                    alert_type={alert_type}
                    organization={organization}
                    openBackdrop={openBackdrop}
                    closeBackdrop={closeBackdrop}
                    showSnackbar={showSnackbar}
                  />
                </Grid>
                )
              })}
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export function AlertSettingsComponent({ organization }) {
  const classes = useStyles();
  const [backdrop, setBackdrop] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState({
    status: 'success',
    description: 'Updated'
  });

  const showSnackbar = (status = 'success', description = 'Updated') => {
    setSnackbar(true);
    setMessage({
      status,
      description
    });
    setBackdrop(false);
  };

  const closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbar(false);
  };

  const closeBackdrop = () => {
    setBackdrop(false);
  };

  const openBackdrop = () => {
    setBackdrop(true);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <AlertSettingsList
            organization={organization}
            openBackdrop={openBackdrop}
            closeBackdrop={closeBackdrop}
            showSnackbar={showSnackbar}
          />
        </Grid>
      </Grid>

      <>
        <Backdrop
          className={classes.backdrop}
          open={backdrop}
          invisible={false}
          onClick={closeBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <SnackbarComponent
          open={snackbar}
          onClose={closeSnackbar}
          severity={message.status}
          message={message.description}
        />
      </>
    </div>
  );
}
